export const INSURANCE_ICON_MAP = {
    CDPHP: "./logo/cdphp.png",
};

export const UNINSURED_OPTION = "No insurance";
export const OUT_OF_NETWORK_INSURANCE_OPTION = "Insurance isn’t on the list";
export const CATCH_ALL_INSURANCE_OPTIONS = [UNINSURED_OPTION, OUT_OF_NETWORK_INSURANCE_OPTION];
